import axios from "axios";
import moment from "moment"; 
// axios.defaults.baseURL = "http://192.168.15.167:64000/api";//testlocale
// axios.defaults.baseURL = "https://portal.easyplanner.it:61001/api";//test vm
axios.defaults.baseURL = "https://portal.easyplanner.it:64001/api";//prod vm
export default {
  JWTToken: "",

  SetJWT: function (jwt) {
    this.Company.JWTToken = jwt;
    this.User.JWTToken = jwt;
    this.Role.JWTToken = jwt;
    this.Customers.JWTToken = jwt;
    this.Headquarters.JWTToken = jwt;
    this.Resources.JWTToken = jwt;
    this.Event.JWTToken = jwt;
    this.Order.JWTToken = jwt;
  },
  
  Order: {
    JWTToken: "",
    ENDPOINT_ORDER: "/companies/:companyAlias/orders/:orderId",
    ENDPOINT_ORDERS: "/companies/:companyAlias/orders",
    Insert: async function (companyAlias, order) {
      return await axios.post(
        this.ENDPOINT_ORDERS.replace(":companyAlias", companyAlias),
        order,
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Update: async function (companyAlias, order) {
      return await axios.put(
        this.ENDPOINT_ORDER.replace(":companyAlias", companyAlias).replace(":orderId", order.idCommessa),
        order,
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    
    Delete: async function (companyAlias, orderId) {
      return await axios.delete(
        this.ENDPOINT_ORDER.replace(":companyAlias", companyAlias).replace(":orderId", orderId), 
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Find: async function (companyAlias, orderId) {
      return await axios.get(
        this.ENDPOINT_ORDER.replace(":companyAlias", companyAlias).replace(
          ":orderId",
          orderId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    GetAll: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_ORDERS.replace(":companyAlias", companyAlias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Search: async function (companyAlias, srcPattern,onlyOpened=false) {
      return await axios.get(
        this.ENDPOINT_ORDERS.replace(":companyAlias", companyAlias),
        {
          params: { src: srcPattern,onlyOpened:onlyOpened },
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  Event: {
    JWTToken: "",
    ENDPOINT_EVENTS: "/companies/:companyAlias/events",
    ENDPOINT_EVENT: "/companies/:companyAlias/events/:eventId",
    ENDPOINT_EVENT_OWNER:
      "/companies/:companyAlias/events/:eventId/idCreatore/:ownerId",
    GetAll: async function (companyAlias, usersEventsOnly = false) {
      return await axios.get(
        this.ENDPOINT_EVENTS.replace(":companyAlias", companyAlias),
        {
          params: { usersEventsOnly: usersEventsOnly },
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Find: async function (companyAlias, eventId) {
      return await axios.get(
        this.ENDPOINT_EVENT.replace(":companyAlias", companyAlias).replace(
          ":eventId",
          eventId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
      
    },
    FindByCompanyAliasDateFromTo: async function (
      companyAlias,
      fromDate,
      toDate,
      usersEventsOnly = false
    ) {
      let dateFrom = moment(fromDate).format("YYYY-MM-DD");
      let dateTo = moment(toDate).format("YYYY-MM-DD");

      return await axios.get(
        this.ENDPOINT_EVENTS.replace(":companyAlias", companyAlias),
        {
          params: {
            fromDate: dateFrom,
            toDate: dateTo,
            usersEventsOnly: usersEventsOnly,
          },
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Delete: async function (companyAlias, eventId) {
      return await axios.delete(
        this.ENDPOINT_EVENT.replace(":companyAlias", companyAlias).replace(
          ":eventId",
          eventId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Insert: async function (companyAlias, event) {
      return await axios.post(
        this.ENDPOINT_EVENTS.replace(":companyAlias", companyAlias),
        event,
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Update: async function (companyAlias, eventId, event) {
      return await axios.put(
        this.ENDPOINT_EVENT.replace(":companyAlias", companyAlias).replace(
          ":eventId",
          eventId
        ),
        event,
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    UpdateOwner: async function (companyAlias, eventId, ownerId) {
      return await axios.patch(
        this.ENDPOINT_EVENT_OWNER.replace(":companyAlias", companyAlias)
          .replace(":eventId", eventId)
          .replace(":ownerId", ownerId),
        event,
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  User: {
    JWTToken: "",
    ENDPOINT_OWNER_LOGINS: "/logins",
    ENDPOINT_OWNER_USERS: "/users",
    ENDPOINT_OWNER_ACTIVATIONS: "/users/activations",
    ENDPOINT_LOGINS: "/companies/:companyAlias/logins",
    ENDPOINT_USERS: "/companies/:companyAlias/users",
    ENDPOINT_USER: "/companies/:companyAlias/users/:utenteId",
    ENDPOINT_USER_BY_RESOURCE:
      "/companies/:companyAlias/resources/:resourceId/user",
    ENDPOINT_USERS_RECOVER: "/users/:usernameOrEmail",
    ENDPOINT_USERS_RECOVERS: "/users/:usernameOrEmail/:otp",
    ENDPOINT_USERS_CHANGEPW: "/users/:usernameOrEmail/:otp/:password",

    GetAll: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_USERS.replace(":companyAlias", companyAlias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Delete: async function (companyAlias, userId) {
      return await axios.delete(
        this.ENDPOINT_USER.replace(":companyAlias", companyAlias).replace(
          ":utenteId",
          userId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Find: async function (companyAlias, userId) {
      return await axios.get(
        this.ENDPOINT_USER.replace(":companyAlias", companyAlias).replace(
          ":utenteId",
          userId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    FindByResourceId: async function (companyAlias, resourceId) {
      return await axios.get(
        this.ENDPOINT_USER_BY_RESOURCE.replace(
          ":companyAlias",
          companyAlias
        ).replace(":resourceId", resourceId),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Insert: async function (companyAlias, Username, Password, Role, Color) {
      return await axios.post(
        this.ENDPOINT_USERS.replace(":companyAlias", companyAlias),
        {
          username: Username,
          password: Password,
          idRuolo: Role,
          colore: Color,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Update: async function (companyAlias, user) {
      return await axios.put(
        this.ENDPOINT_USER.replace(":companyAlias", companyAlias).replace(
          ":utenteId",
          user.idUtente
        ),
        user,
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    RefreshToken: async function (token, companyAlias) {
      return axios.post(
        this.ENDPOINT_LOGINS.replace(":companyAlias", companyAlias),
        {
          token: token, 
          username: "",
          password: "",
        }
      );
    },
    Login: async function (username, password, companyAlias) {
      return await axios.post(
        this.ENDPOINT_LOGINS.replace(":companyAlias", companyAlias),
        {
          username: username,
          password: password,
          token:""
        }
      );
    },

    LoginOwner: async function (username, password) {
      return await axios.post(this.ENDPOINT_OWNER_LOGINS, {
        username: username,
        password: password,
      });
    },
    SignUpOwner: async function (email, username, password) {
      return await axios.post(this.ENDPOINT_OWNER_USERS, {
        email: email,
        username: username,
        password: password,
      });
    },

    ActivateUser: async function (token, activationCode) {
      return await axios.post(this.ENDPOINT_OWNER_ACTIVATIONS, {
        token: token,
        activationCode: activationCode,
      });
    },

    RecoverPassword: async function (usernameOrEmail) {
      return await axios.put(
        this.ENDPOINT_USERS_RECOVER.replace(
          ":usernameOrEmail",
          usernameOrEmail
        ),
        {}
      );
    },

    ValidateOTPCode: async function (usernameOrEmail, otpCode) {
      return await axios.get(
        this.ENDPOINT_USERS_RECOVERS.replace(
          ":usernameOrEmail",
          usernameOrEmail
        ).replace(":otp", otpCode),
        {}
      );
    },

    ChangePassword: async function (usernameOrEmail, otpCode, newPassword) {
      return await axios.put(
        this.ENDPOINT_USERS_CHANGEPW.replace(
          ":usernameOrEmail",
          usernameOrEmail
        )
          .replace(":otp", otpCode)
          .replace(":password", newPassword),
        {}
      );
    },
  },
  Company: {
    JWTToken: "",
    ENDPOINT_COMPANIES: "/companies",
    ENDPOINT_COMPANY: "/companies/:companyAlias",
    ENDPOINT_COMPANY_UISETTINGS: "/companies/:companyAlias/UISettings",
    ENDPOINT_COMPANY_LOGO: "/companies/:companyAlias/logo",
    AddCompany: async function (
      companyName,
      vatNumber,
      address,
      cap,
      city,
      province,
      phone
    ) {
      return await axios.post(
        this.ENDPOINT_COMPANIES,
        {
          ragioneSociale: companyName,
          partitaIva: vatNumber,
          indirizzo: address,
          cap: cap,
          citta: city,
          provincia: province,
          telefono: phone,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    UpdateCompany: async function (
      companyAlias,
      companyName,
      vatNumber,
      address,
      cap,
      city,
      province,
      phone
    ) {
      return await axios.put(
        this.ENDPOINT_COMPANY.replace(":companyAlias", companyAlias),
        {
          ragioneSociale: companyName,
          partitaIva: vatNumber,
          indirizzo: address,
          cap: cap,
          citta: city,
          provincia: province,
          telefono: phone,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    UpdateLogo: async function (companyAlias, fileName, base64Logo) {
      console.debug("LOGOOOOO", base64Logo);
      return await axios.patch(
        this.ENDPOINT_COMPANY_LOGO.replace(":companyAlias", companyAlias),
        { base64Content: base64Logo },
        {
          params: { fileName: fileName },
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    PushUISettings: async function (companyAlias, UISettings) {
      return await axios.patch(
        this.ENDPOINT_COMPANY_UISETTINGS.replace(":companyAlias", companyAlias),
        { UISettings },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    PullUISettings: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_COMPANY_UISETTINGS.replace(":companyAlias", companyAlias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    GetAll: async function () {
      return await axios.get(this.ENDPOINT_COMPANIES, {
        params: {},
        headers: { Authorization: `Bearer ${this.JWTToken}` },
      });
    },
    FindByAlias: async function (alias) {
      return await axios.get(
        this.ENDPOINT_COMPANY.replace(":companyAlias", alias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  Role: {
    JWTToken: "",
    ENDPOINT_ROLES: "/companies/:companyAlias/roles",
    ENDPOINT_ROLE: "/companies/:companyAlias/roles/:roleId",

    Delete: async function (companyAlias, roleId) {
      return await axios.delete(
        this.ENDPOINT_ROLE.replace(":companyAlias", companyAlias).replace(
          ":roleId",
          roleId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    GetAll: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_ROLES.replace(":companyAlias", companyAlias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Insert: async function (companyAlias, description) {
      return await axios.post(
        this.ENDPOINT_ROLES.replace(":companyAlias", companyAlias),
        {
          description: description,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Update: async function (companyAlias, role) {
      return await axios.put(
        this.ENDPOINT_ROLE.replace(":companyAlias", companyAlias).replace(
          ":roleId",
          role.id
        ),
        role,
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    // Add:async function(companyName,vatNumber,address,phone){
    //     return  await  axios.post(this.ENDPOINT_COMPANIES,
    //         {
    //             ragioneSociale:companyName,
    //             partitaIva:vatNumber,
    //             indirizzo:address,
    //             telefono:phone
    //         },
    //         {
    //             headers: {"Authorization" : `Bearer ${this.JWTToken}`}
    //         }
    //         );
    // },

    // Update:async function(companyAlias,companyName,vatNumber,address,phone){
    //     return  await  axios.put(this.ENDPOINT_COMPANY.replace(":companyAlias",companyAlias),
    //         {
    //             ragioneSociale:companyName,
    //             partitaIva:vatNumber,
    //             indirizzo:address,
    //             telefono:phone
    //         },
    //         {
    //             headers: {"Authorization" : `Bearer ${this.JWTToken}`}
    //         }
    //         );
    // },
  },
  Customers: {
    JWTToken: "",
    ENDPOINT_CUSTOMER: "/companies/:companyAlias/customers/:customerId",
    ENDPOINT_CUSTOMERS: "/companies/:companyAlias/customers",

    Delete: async function (companyAlias, customerId) {
      return await axios.delete(
        this.ENDPOINT_CUSTOMER.replace(":companyAlias", companyAlias).replace(
          ":customerId",
          customerId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    GetAll: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_CUSTOMERS.replace(":companyAlias", companyAlias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    Find: async function (companyAlias, customerId) {
      return await axios.get(
        this.ENDPOINT_CUSTOMER.replace(":companyAlias", companyAlias).replace(
          ":customerId",
          customerId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Insert: async function (
      companyAlias,
      descrizione,
      indirizzo,
      cap,
      citta,
      provincia,
      telefono,
      mail,
      idSedePrincipale,
      sedi
    ) {
      console.debug("idSedePrincipale", idSedePrincipale);
      return await axios.post(
        this.ENDPOINT_CUSTOMERS.replace(":companyAlias", companyAlias),
        {
          descrizione: descrizione,
          indirizzo: indirizzo,
          cap: cap,
          città: citta,
          provincia: provincia,
          telefono: telefono,
          mail: mail,
          idSedePrincipale: idSedePrincipale,
          sedi: sedi,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Update: async function (companyAlias, customer) {
      return await axios.put(
        this.ENDPOINT_CUSTOMER.replace(":companyAlias", companyAlias).replace(
          ":customerId",
          customer.idCliente
        ),
        customer,
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  Headquarters: {
    JWTToken: "",
    ENDPOINT_HEADQUARTERS:
      "/companies/:companyAlias/customers/:clienteId/headquarters",
    ENDPOINT_HEADQUARTER:
      "/companies/:companyAlias/customers/:clienteId/headquarters/:headquarterId",

    Delete: async function (companyAlias, customerId, headquarterId) {
      return await axios.delete(
        this.ENDPOINT_HEADQUARTER.replace(":companyAlias", companyAlias)
          .replace(":clienteId", customerId)
          .replace(":headquarterId", headquarterId),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    GetAll: async function (companyAlias, clienteId) {
      return await axios.get(
        this.ENDPOINT_HEADQUARTERS.replace(
          ":companyAlias",
          companyAlias
        ).replace(":clienteId", clienteId),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Find: async function (companyAlias, clienteId, headquarterId) {
      return await axios.get(
        this.ENDPOINT_HEADQUARTER.replace(":companyAlias", companyAlias)
          .replace(":clienteId", clienteId)
          .replace(":headquarterId", headquarterId),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Insert: async function (
      companyAlias,
      indirizzo,
      cap,
      citta,
      provincia,
      clienteId
    ) {
      return await axios.post(
        this.ENDPOINT_HEADQUARTERS.replace(
          ":companyAlias",
          companyAlias
        ).replace(":clienteId", clienteId),
        {
          indirizzo: indirizzo,
          cap: cap,
          citta: citta,
          provincia: provincia,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  Permissions: {
    JWTToken: "",
    ENDPOINT_PERMISSIONS: "/permissions",
    GetAll: async function () {
      return await axios.get(this.ENDPOINT_PERMISSIONS);
    },
  },
  Resources: {
    JWTToken: "",
    ENDPOINT_RESOURCE_OPERATORS: "/companies/:companyAlias/operators",
    ENDPOINT_RESOURCE_VEHICLES: "/companies/:companyAlias/vehicles",
    ENDPOINT_RESOURCE_EQUIPMENTS: "/companies/:companyAlias/equipments",
    ENDPOINT_RESOURCES: "/companies/:companyAlias/resources",
    ENDPOINT_EVENT_RESOURCES:
      "/companies/:companyAlias/events/:eventId/resources",
    ENDPOINT_RESOURCE: "/companies/:companyAlias/resources/:resourceId",
    ENDPOINT_RESOURCE_SORTORDER:
      "/companies/:companyAlias/resourcesList/sortOrder",

    Delete: async function (companyAlias, resourceId) {
      return await axios.delete(
        this.ENDPOINT_RESOURCE.replace(":companyAlias", companyAlias).replace(
          ":resourceId",
          resourceId
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    ChangeSortOrder: async function (companyAlias, resources) {
      let sortList = [];
      for (let i = 0; i < resources.length; i++) {
        let res = resources[i];
        sortList.push({
          idRisorsa: res.idRisorsa,
          prioritaOrdinamento: res.prioritaOrdinamento,
        });
      }
      return await axios.patch(
        this.ENDPOINT_RESOURCE_SORTORDER.replace(":companyAlias", companyAlias),
        sortList,
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    GetAllOperators: async function (companyAlias, withoutUserOnly = false) {
      return await axios.get(
        this.ENDPOINT_RESOURCE_OPERATORS.replace(":companyAlias", companyAlias),
        {
          params: { withoutUserOnly: withoutUserOnly },
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
    FindByEventId: async function (companyAlias, eventId) {
      return await axios.get(
        this.ENDPOINT_EVENT_RESOURCES.replace(
          ":companyAlias",
          companyAlias
        ).replace(":eventId", eventId),
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    GetAllVehicles: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_RESOURCE_VEHICLES.replace(":companyAlias", companyAlias),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    GetAllEquipments: async function (companyAlias) {
      return await axios.get(
        this.ENDPOINT_RESOURCE_EQUIPMENTS.replace(
          ":companyAlias",
          companyAlias
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Insert: async function (companyAlias, Description, Tipo) {
      return await axios.post(
        this.ENDPOINT_RESOURCES.replace(":companyAlias", companyAlias),
        {
          descrizione: Description,
          tipo: Tipo,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    InsertWorker: async function (
      companyAlias,
      Description,
      Tipo,
      utente = null
    ) {
      return await axios.post(
        this.ENDPOINT_RESOURCES.replace(":companyAlias", companyAlias),
        {
          descrizione: Description,
          tipo: Tipo,
          utente: utente,
        },
        {
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },

    Update: async function (companyAlias, resource) {
      return await axios.put(
        this.ENDPOINT_RESOURCE.replace(":companyAlias", companyAlias).replace(
          ":resourceId",
          resource.idRisorsa
        ),
        resource,
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  Counters: {
    ENDPOINT_COUNTERS: "/companies/:companyAlias/counters/:counterType",

    GetCounter: async function (alias, counterType) {
      return await axios.get(
        this.ENDPOINT_COUNTERS.replace(":companyAlias", alias).replace(
          ":counterType",
          counterType
        ),
        {
          params: {},
          headers: { Authorization: `Bearer ${this.JWTToken}` },
        }
      );
    },
  },
  GetErrorDescription: function (errorCode) {
    switch (errorCode) {
      case "ACCESS_DENIED":
        return "Access Denied. You don't have permission to access this page.";
      case "USER_NOT_FOUND":
        return "User Not Found";
      case "INVALID_DATA":
        return "Invalid Data. Please try again.";
      case "USER_EXPIRED":
        return "User Expired. Please try again Expired. Please try again.";
      case "USER_DISABLED":
        return "User Disabled. Please try again.";
      case "NOT_FOUND":
        return "Not Found. Please try again.";
      case "BAD_REQUEST":
        return "Sorry, something went wrong. Please try again.";
      case "INVALID_ACCOUNT":
        return "Invalid Account. Please check your credentials then try again.";
      case "INTERNAL_SERVER_ERROR":
        return "Sorry, something went wrong. Please try again.";
      case "USER_ALREADY_EXISTS":
        return "Sorry, a user with this username already exists. Please try again with another one.";
      case "ROLE_ALREADY_EXISTS":
        return "Sorry, this role already exists. Please try again with another one.";
      case "INVALID_ACTIVATION_CODE":
        return "Invalid Activation Code. Please try again.";
      case "AUTHENTICATION_REQUIRED":
        return "Authentication is Required. You need to sign in.";
      case "INVALID_COMPANY":
        return "Invalid Company. Please try again.";
      case "INVALID_COMPANY_NAME":
        return "Invalid Company Name. Please try again.";
      case "INVALID_VAT_NUMBER":
        return "Invalid VAT Number. Please try again.";
      case "NOT_AUTHORIZED":
        return "Sorry, you are not authorized to view the requested page.";
      case "OWNER_HAS_NOT_COMPANY":
        return "Owner doesn't have a registered company. Please register your company details.";
      case "USER_IS_NOT_VERIFIED":
        return "User is not verified. Please verify your account.";
      case "COMPANY_NOT_FOUND":
        return "Company Not Found. Please try again.";
      case "INVALID_ROLE":
        return "Invalid Role. Please try again.";
      case "RESOURE_ALREADY_EXISTS":
        return "This description already exists. Please try again with a different one.";
      default:
        return errorCode;
    }
  },
};
